import React from 'react'
import { useNavigate } from 'react-router-dom'
import { FormGroup, FormControl, Card, Collapse } from 'react-bootstrap'
import { navigate } from 'react-big-calendar/lib/utils/constants'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { searchAppointments, getAppointment } from './../../logic/calendar'
import moment from 'moment'

class CustomToolbarClass extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      searchBarVisible: false,
      searchQuery: '',
      showResults: false,
      searchResult: [],
      retrievePast: true, // Always set to true to show all appointments by default
      isSearching: false
    }
    
    console.log('CustomToolbar constructor props:', props);
    
    // Always set retrievePast to true in localStorage to show all appointments
    window.localStorage.setItem('currentRetrievePast', true);
  }
  
  componentDidMount = () => {
    console.log('CustomToolbar mounted with props:', this.props);
    
    // Add click outside handler to close search results
    document.addEventListener('click', this.handleClickOutside)
  }

  componentWillUnmount = () => {
    // Remove click outside handler
    document.removeEventListener('click', this.handleClickOutside)
  }

  handleClickOutside = (event) => {
    // Close search popup if clicking outside the popup
    if (this.state.showResults && !event.target.closest('.calendar__search-popup--popup')) {
      this.setState({ showResults: false })
    }
    if (this.state.searchBarVisible && !event.target.closest('.calendar__toolbar--view') && !event.target.closest('.calendar__toolbar--search-trigger')) {
      this.setState({ searchBarVisible: false, showResults: false })
    }
  }
  
  goToBack = () => {
    console.log('Going back, props:', this.props);
    // Force a delay to avoid race conditions in setState operations
    setTimeout(() => {
      if (this.props && this.props.onNavigate) {
        this.props.onNavigate(navigate.PREVIOUS);
      } else if (this.props.toolbar && this.props.toolbar.onNavigate) {
        this.props.toolbar.onNavigate(navigate.PREVIOUS);
      } else {
        console.error('Navigation function not available');
      }
    }, 0);
  }
  
  goToNext = () => {
    console.log('Going next, props:', this.props);
    // Force a delay to avoid race conditions in setState operations
    setTimeout(() => {
      if (this.props && this.props.onNavigate) {
        this.props.onNavigate(navigate.NEXT);
      } else if (this.props.toolbar && this.props.toolbar.onNavigate) {
        this.props.toolbar.onNavigate(navigate.NEXT);
      } else {
        console.error('Navigation function not available');
      }
    }, 0);
  }
  
  goToCurrent = () => {
    console.log('Going to today, props:', this.props);
    // Force a delay to avoid race conditions in setState operations
    setTimeout(() => {
      if (this.props && this.props.onNavigate) {
        this.props.onNavigate(navigate.TODAY);
      } else if (this.props.toolbar && this.props.toolbar.onNavigate) {
        this.props.toolbar.onNavigate(navigate.TODAY);
      } else {
        console.error('Navigation function not available');
      }
    }, 0);
  }
  
  getLabel = () => {
    console.log('Getting label, props:', this.props);
    // First try direct props
    if (this.props && typeof this.props.label === 'string') {
      return this.props.label;
    }
    
    // Then try toolbar props
    if (this.props.toolbar && typeof this.props.toolbar.label === 'string') {
      return this.props.toolbar.label;
    }
    
    // Fallback to date formatting
    const date = (this.props && this.props.date) || 
                 (this.props.toolbar && this.props.toolbar.date) || 
                 new Date();
                 
    // Format differently based on view
    const currentView = this.props.view || (this.props.toolbar && this.props.toolbar.view) || 'month';
    
    if (currentView === 'agenda' || currentView === 'billing') {
      return `${currentView.charAt(0).toUpperCase() + currentView.slice(1)} for ${moment(date).format('MMMM D, YYYY')}`;
    }
    
    return moment(date).format('MMMM YYYY');
  }
  
  // This function is kept for future reference but won't be used in the UI
  toggleRetrievePast = () => {
    // Functionality is disabled - always showing past appointments
    // Original implementation kept for future reference:
    /*
    let newRetrievePast = this.state.retrievePast

    if (newRetrievePast === "true" || newRetrievePast === true) newRetrievePast = false;
    else newRetrievePast = true;

    window.localStorage.setItem('currentRetrievePast', newRetrievePast);
    this.setState({ retrievePast: newRetrievePast }, () => window.location.reload(false));
    */
    
    // Now we just ensure retrievePast is always true
    window.localStorage.setItem('currentRetrievePast', true);
    this.setState({ retrievePast: true });
  }
  
  handleViewChange = view => {
    console.log('Changing view to:', view);
    if (this.props && this.props.onView) {
      this.props.onView(view);
    } else if (this.props.toolbar && this.props.toolbar.onView) {
      this.props.toolbar.onView(view);
    } else {
      console.error('View change function not available');
    }
  }
  
  toggleSearchBar = (e, val) => {
    e.preventDefault()
    e.stopPropagation()

    this.setState({
      searchQuery: '',
      searchBarVisible: val,
      searchResult: [],
      showResults: false,
      isSearching: false
    })
  }
  
  startSearch = async e => {
    e.preventDefault()
    e.stopPropagation()

    let query = this.state.searchQuery.trim()
    
    if (!query) {
      console.log('Empty search query, not proceeding')
      return
    }
    
    if (query.length < 2) {
      console.log('Search query too short, not proceeding')
      return
    }

    this.setState({ 
      searchBarVisible: true,
      searchResult: [],
      showResults: false,
      isSearching: true
    })

    // Clean up mobile number searches by removing common formatting characters
    if (query.match(/^[\d\s\-\+\(\)]+$/)) {
      query = query.replace(/[\s\-\+\(\)]/g, '')
      console.log('Cleaned mobile number query:', query)
    }

    console.log('Starting search for:', query)
    console.log('Doctor ID:', window.localStorage.getItem('currentDoctorId'))

    try {
      const searchResult = await searchAppointments(
        window.localStorage.getItem('currentDoctorId'),
        query,
      )
      const appointments = []

      console.log('Raw search result:', searchResult)

      if (
        searchResult &&
        searchResult instanceof Array &&
        searchResult.length > 0
      ) {
        for (const r of searchResult) {
          console.log('Search result item:', r)
          appointments.push(r)
        }
        this.setState({ 
          searchResult: appointments, 
          showResults: true,
          isSearching: false
        })
        console.log(`Found ${appointments.length} appointments`)
      } else {
        // Handle case when no results are found
        this.setState({ 
          searchResult: [], 
          showResults: true,
          isSearching: false
        })
        console.log('No search results found for query:', query)
      }
    } catch (e) {
      console.error('Search error:', e)
      // Handle search errors
      this.setState({ 
        searchResult: [], 
        showResults: true,
        isSearching: false
      })
    }
  }
  
  goToAppointment = async (e, creationTimestamp) => {
    e.preventDefault()
    e.stopPropagation()

    try {
      const item = await getAppointment(
        window.localStorage.getItem('currentDoctorId'),
        creationTimestamp,
      )
      
      // React Router v6 navigation
      if (this.props.navigate) {
        this.props.navigate(`/appointments/${creationTimestamp}`, { 
          state: { item }
        });
      } else {
        console.error('Navigation function not available');
      }
    } catch (e) {
      console.log(e)
    }
  }
  
  firstAvailability = () => {
    if (this.props.firstAvailability && typeof this.props.firstAvailability === 'function') {
      this.props.firstAvailability();
    }
  }
  
  render = () => {
    // MOBILE FIX: Detect if we're on a small screen
    const isSmallScreen = window.innerWidth < 520;
    
    // Get the current view from props
    const currentView = this.props.view || (this.props.toolbar && this.props.toolbar.view) || 'month';
    
    return (
      <div className="toolbar-container">
        <div className="calendar__toolbar--nav-buttons">
          <button
            className="calendar__toolbar--today-button"
            onClick={this.goToCurrent}
          >
            TODAY
          </button>
          <button
            className="calendar__toolbar--back-button"
            onClick={this.goToBack}
          >
            &lt;
          </button>

          <button
            className="calendar__toolbar--next-button"
            onClick={this.goToNext}
          >
            &gt;
          </button>
          <label className="calendar__toolbar--label">{this.getLabel()}</label>
          
          {/* Past appointments button removed from UI, code kept for future reference
          <button
            className="calendar__toolbar--today-button"
            style={{ marginLeft: "5px", padding: "5px" }}
            onClick={this.toggleRetrievePast}
          >
            {this.state.retrievePast === true || this.state.retrievePast === "true" ? "Do not show past appointments" : "Show past appointments"}
          </button>
          */}
        </div>

        <FormGroup className="calendar__toolbar--view">
          <div>
            {this.state.searchBarVisible === false ? (
              <button
                onClick={e => this.toggleSearchBar(e, true)}
                className="calendar__toolbar--search-button calendar__toolbar--search-trigger"
              >
                <FontAwesomeIcon icon={faSearch} />
              </button>
            ) : (
              <div>
                <form onSubmit={this.startSearch} className="flex-row calendar__toolbar--search-form">
                  <FormControl
                    className="calendar__toolbar--search-bar"
                    id="search-bar"
                    autoFocus
                    autoComplete="off"
                    value={this.state.searchQuery}
                    placeholder="Search by name, mobile, ID card, or email"
                    onChange={e => {
                      const value = e.target.value
                      this.setState({ 
                        searchQuery: value,
                        searchResult: value ? this.state.searchResult : [],
                        showResults: value ? this.state.showResults : false
                      })
                    }}
                    type="text"
                  ></FormControl>
                  <input
                    type="submit"
                    className="calendar__toolbar--search-start-button"
                    value={this.state.isSearching ? "SEARCHING..." : "SEARCH"}
                    disabled={this.state.isSearching}
                  />
                  <FontAwesomeIcon
                    className="calendar__toolbar--search-cancel-button"
                    icon={faTimes}
                    onClick={e => this.toggleSearchBar(e, false)}
                  />
                </form>
                
                {/* Search Results Popup */}
                {this.state.showResults && (
                  <div className="calendar__search-popup--container">
                    <div className="calendar__search-popup--popup">
                      <div className="calendar__search-popup--header">
                        <h3>Search Results for: "{this.state.searchQuery}"</h3>
                        {this.state.searchResult.length > 0 && (
                          <div className="calendar__search-popup--count">
                            Found {this.state.searchResult.length} appointment{this.state.searchResult.length !== 1 ? 's' : ''}
                          </div>
                        )}
                        <button 
                          className="calendar__search-popup--close"
                          onClick={() => this.setState({ showResults: false })}
                        >
                          <FontAwesomeIcon icon={faTimes} />
                        </button>
                      </div>
                      
                      <div className="calendar__search-popup--content">
                        {this.state.isSearching ? (
                          <div className="calendar__search-popup--loading">
                            <p>Searching...</p>
                          </div>
                        ) : this.state.searchResult.length > 0 ? (
                          <div className="calendar__search-popup--results">
                            {this.state.searchResult.map((result, i) => {
                              return (
                                <div
                                  className="calendar__search-popup--result-item"
                                  onClick={e => this.goToAppointment(e, result.creationTimestamp)}
                                  key={i}
                                >
                                  <div className="calendar__search-popup--result-date">
                                    {moment(result.fromTimestamp).format('DD MMM YYYY')}
                                  </div>
                                  <div className="calendar__search-popup--result-time">
                                    {moment(result.fromTimestamp).format('HH:mm')} - {moment(result.toTimestamp).format('HH:mm')}
                                  </div>
                                  <div className="calendar__search-popup--result-patient">
                                    {result.patient.name.firstName} {result.patient.name.lastName}
                                  </div>
                                  {result.patient.idCard && (
                                    <div className="calendar__search-popup--result-id">
                                      ID: {result.patient.idCard}
                                    </div>
                                  )}
                                  {result.patient.mobile && result.patient.mobile.mobileNumber && (
                                    <div className="calendar__search-popup--result-mobile">
                                      {result.patient.mobile.countryPrefixCode ? '+' + result.patient.mobile.countryPrefixCode : ''}{result.patient.mobile.mobileNumber}
                                    </div>
                                  )}
                                </div>
                              )
                            })}
                          </div>
                        ) : this.state.searchQuery.trim() ? (
                          <div className="calendar__search-popup--no-results">
                            <p>No appointments found matching "{this.state.searchQuery}"</p>
                          </div>
                        ) : (
                          <div className="calendar__search-popup--empty">
                            <p>Enter a search term to find appointments</p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          <button
            className="calendar__toolbar--first-availability-button"
            onClick={this.firstAvailability}
          >
            First Availability
          </button>
          <FormControl
            id="view"
            value={currentView}
            className="calendar__toolbar--views noprint"
            as="select"
            onChange={e => this.handleViewChange(e.target.value)}
          >
            {/* MOBILE FIX: Only show supported views on mobile devices */}
            {!isSmallScreen && <option value="month">Month</option>}
            {!isSmallScreen && <option value="week">Week</option>}
            <option value="day">Day</option>
            <option value="agenda">Agenda</option>
            <option value="billing">Billing</option>
          </FormControl>
        </FormGroup>
      </div>
    )
  }
}

// Wrapper with useNavigate hook
const ToolbarWithNavigate = (props) => {
  const navigate = useNavigate();
  return <CustomToolbarClass {...props} navigate={navigate} />;
}

export default ToolbarWithNavigate;
